import { render } from "./InvestForm.vue?vue&type=template&id=2cdca853"
import script from "./InvestForm.vue?vue&type=script&lang=js"
export * from "./InvestForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__